/**
 * 815 Digital Services — official brand mark.
 *
 * v1.5: renders the ACTUAL logo file supplied by 815 Digital Services
 * (`/public/brand/815-digital-services-logo.png`) exactly as provided —
 * no recreation, approximation, or redesign. Kept as a single, fixed-
 * aspect container so the file can be swapped later (e.g. for a vector
 * version) without touching any layout that consumes this component.
 */
const SIZE_CLASSES = {
  lg: "h-28 w-28 rounded-2xl",
  sm: "h-16 w-16 rounded-xl",
};

export const BrandLogoMark = ({ size = "lg", className = "" }) => {
  const box = SIZE_CLASSES[size] || SIZE_CLASSES.lg;
  return (
    <div
      className={`${box} overflow-hidden shadow-lg shrink-0 ${className}`}
      data-testid="login-brand-logo"
    >
      <img
        src="/brand/815-digital-services-logo.png"
        alt="815 Digital Services"
        className="h-full w-full object-cover"
        draggable="false"
      />
    </div>
  );
};
